/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ris.vue?vue&type=template&id=2e21bca9"
import script from "./ris.vue?vue&type=script&lang=js"
export * from "./ris.vue?vue&type=script&lang=js"
import style0 from "./ris.vue?vue&type=style&index=0&id=2e21bca9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports